import { observer } from 'mobx-react-lite'
import { TagsSelect } from 'entities/Tags/ui/TagSelect/TagsSelect'
import type { TagsControl } from 'entities/Tags/store/tagsControl'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/styles.module.scss'

type IActionsStep3TagProps = {
  tagsControl: TagsControl
  canCreate: boolean
}

export const ActionsStep3Tag = observer(({ tagsControl, canCreate }: IActionsStep3TagProps) => (
  <div className={styles.actionStep}>
    <TagsSelect control={tagsControl} canCreate={canCreate} placement='top' />
  </div>
))
